module.exports = __webpack_public_path__ + "static/media/300.f7b0aa84.svg";